import { useReaderContext } from '../../Contexts/Modules/ReaderModule/ReaderModule'

export function useContainerPayload() {
  const { containerSelectionModel, barcodes, mutateBarcodes } =
    useReaderContext()
  const payload: any[] = []
  containerSelectionModel.forEach((id) => {
    payload.push({
      ContainerID: id,
      Timestamp: barcodes[id],
      RackID: mutateBarcodes.data?.containers.found[id].RackID,
    })
  })
  return payload
}

export function useVesselPayload() {
  const { vesselSelectionModel, barcodes } = useReaderContext()
  const payload: any[] = []
  vesselSelectionModel.forEach((id) => {
    payload.push({
      VesselID: id,
      Timestamp: barcodes[id],
    })
  })
  return payload
}

export function useBarcodePayload() {
  return {
    containers: useContainerPayload(),
    vessels: useVesselPayload(),
  }
}
